import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, TextField, Button } from "@material-ui/core";

const useStyles = theme => ({
    element: {
        margin: theme.spacing(1)
    }
});

const UserProfile = props => {
    const { classes, containerClass, onSubmit, name } = props;
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(name);
    }, [name]);

    const handleSubmit = () => {
        onSubmit && onSubmit(value);
    }

    return (
        <div className={containerClass}>
            <TextField
                label="Imię i nazwisko"
                fullWidth
                className={classes.element}
                value={value}
                onChange={e => setValue(e.target.value)}
            />
            <Button
                variant='contained'
                color='primary'
                fullWidth
                className={classes.element}
                onClick={handleSubmit}
            >
                Zatwierdź
            </Button>
        </div>
    )
}

UserProfile.propTypes = {
    classes: PropTypes.object,
    containerClass: PropTypes.string,
    onSubmit: PropTypes.func
}

export default withStyles(useStyles)(UserProfile);
